import {
  Component,
  ViewChild,
  ElementRef,
  Input,
  Output,
  EventEmitter,
  OnChanges
} from '@angular/core';
import { Router } from '@angular/router';
import { SnotifyService } from 'ng-snotify';
import { LocalsService } from '../../locals.service';

@Component({
  selector: 'app-view-admin-approval',
  templateUrl: './view-admin-approval.component.html',
  styleUrls: ['./view-admin-approval.component.css']
})
export class ViewAdminApprovalComponent implements OnChanges {
  @ViewChild('modal', { static: true }) modal: ElementRef;
  @ViewChild('closeAddExpenseModal', { static: false })
  closeAddExpenseModal: ElementRef;
  @Input() Local;
  @Output() return = new EventEmitter();
  local: any;
  constructor(
    private localsApi: LocalsService,
    private notifier: SnotifyService,
    private router: Router
  ) {}

  ngOnChanges() {
    // this.local=new Local()
    // console.log(this.Local)
    this.local = this.Local;
  }
  Approve() {
    this.localsApi
      .patchAdminApprovalStatus({
        uuid: this.local.uuid,
        adminApproval: 'APPROVED'
      })
      .subscribe(
        Response => {
          // console.log(Response)
          this.notifier.success('Admin Appove Status is Updated Successfully');
          this.return.emit({ flag: true });
        },
        err => {
          this.notifier.error(err.error.userMessage);
        }
      );
    this.closeAddExpenseModal.nativeElement.click();
  }
  Decline() {
    this.localsApi
      .patchAdminApprovalStatus({
        uuid: this.local.uuid,
        adminApproval: 'DECLINED'
      })
      .subscribe(
        Response => {
          // console.log(Response)
          this.notifier.success('Admin Appove Status is Updated Successfully');
          this.return.emit({ flag: true });
        },
        err => {
          this.notifier.error(err.error.userMessage);
        }
      );
    this.closeAddExpenseModal.nativeElement.click();
  }
}
